export default __webpack_public_path__ + "static/media/icon_facebook_messenger.02d69e58.svg";